var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c(
            "div",
            { staticClass: "ibox-title" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  on: {
                    click: function($event) {
                      _vm.edit()
                    }
                  }
                },
                [_vm._v("修改")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("ul", [
              _c("li", { staticClass: "mess_li" }, [
                _c("span", { staticClass: "fileing" }, [_vm._v("转诊医院：")]),
                _vm._v(" "),
                _c("div", { staticClass: "filediv" }, [
                  _vm._v(_vm._s(_vm.referralName))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "mess_li" }, [
                _c("span", { staticClass: "fileing" }, [_vm._v("医院地址：")]),
                _vm._v(" "),
                _c("div", { staticClass: "filediv" }, [
                  _vm._v(_vm._s(_vm.address))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-279d4920", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279d4920","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/referral/referralDetail.vue
// module id = null
// module chunks = 